import { Provider } from '@cloud-native/workflows-engine'
import { getClient } from 'features/common/utils/clientParameter'
import { sendSQLRequestWithRetries } from 'features/sql/api/sql'
import { selectTempRegion } from '../../model/selectors/workflow'
import { OptionParams } from './interface'
import { getStore } from 'app/state/storeRegistry'
import { buildAuditTags } from 'features/common/utils/buildAuditTags'

export class SqlQueryExecutor {
  #getExecuteSqlOptions(options?: Partial<OptionParams>) {
    const sqlOptions = {
      client: getClient(),
      returnResults: options?.returnResults
    }

    // TODO not using WorkflowStoreManager to avoid wrong coupling of classes
    // WorkflowManager (WorkflowStoreManager) <- ReduxManager (setters & getters)
    // SqlQueryExecutor <- ReduxManager (setters & getters)
    const workflow = options?.workflow || getStore().getState().workflows.workflow
    if (workflow?.id) {
      Object.assign(sqlOptions, buildAuditTags({ workflowId: workflow?.id }))
    }
    if (workflow?.config?.connectionProvider === Provider.BigQuery) {
      sqlOptions['bigquery.location'] = selectTempRegion(workflow)
    }

    return sqlOptions
  }

  async execute<T>(
    query: string,
    connection: string,
    options?: {
      options?: Partial<OptionParams>
      retry?: number
      signal?: AbortSignal
    }
  ) {
    const sqlResponse = await sendSQLRequestWithRetries(options?.retry, {
      connection,
      query,
      extraParams: this.#getExecuteSqlOptions(options?.options),
      refresh: true,
      signal: options?.signal
    })
    return sqlResponse.rows as T
  }
}
